// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2c1aab07","239":"13ecc606","455":"8334abe7"}[chunkId] + ".chunk.js";
};